import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { getTransFunc } from '../../../Basic/SFxLocalization';

var Start = /*#__PURE__*/function (_React$Component) {
  _inherits(Start, _React$Component);

  var _super = _createSuper(Start);

  function Start() {
    _classCallCheck(this, Start);

    return _super.apply(this, arguments);
  }

  _createClass(Start, [{
    key: "render",
    value: function render() {
      var trans = getTransFunc();
      var solutionName = this.props.options.solutionName ? "SFx ".concat(this.props.options.solutionName) : 'SFx';
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, trans('SFxUserProfileCompleteContent')), /*#__PURE__*/React.createElement("p", null, trans('SFxUserProfileStartExploring', solutionName)));
    }
  }]);

  return Start;
}(React.Component);

export { Start as default };